import { apiFetch } from "../utils/apiFetch"

export type PatentDocumentType =
  | "DESCRIPTION"
  | "CLAIMS"
  | "ABSTRACT"
  | "DRAWINGS"
  | "BIOLOGICAL_MATERIAL"
  | "SEQUENCE_LISTING"
  | "OTHER"
  | "PRIORITY_TRANSLATION"
  | "INTERNATIONAL_TRANSLATION"
  | "AMENDED_DESCRIPTION"
  | "AMENDED_CLAIMS"
  | "AMENDED_DRAWINGS"
  | "IPER_TRANSLATION"
  | "AMENDED_CLAIMS_TRANSLATION"
  | "UNCONVERTED_ARCHIVE"

export async function uploadPatentDocument(
  file: File,
  type: PatentDocumentType
): Promise<{ type: PatentDocumentType; documentId: string; fileName: string }> {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("type", type)

  return apiFetch("/api/euipo/patent-filing/documents/upload", {
    method: "POST",
    body: formData
  })
}
